export default __webpack_public_path__ + "static/media/3.ca33e7dd.jpg";